module.exports = __webpack_public_path__ + "static/kickstarter-a0562bd9e2e1cbeda8703e4a34fe73d7.png";